import { LogementPageBase, ViewKind } from "../LogementPageBase";

export const NewLogementPage = () => {
    return <LogementPageBase viewKind={ViewKind.New} />;
};
